<template>
  <tr class="mortgage-row-component">
    <td><a v-bind:href="mortgageShowUri"> {{ mortgage.hypotheeknummer || 'Geen hypotheeknummer' }}</a></td>
    <td>{{ mortgage.redenHypotheek }}</td>
    <td>
      <span class="tooltip-toggle" data-placement="right" data-toggle="tooltip"
            style="white-space: nowrap;" title="Passeerdatum">{{ formatDate(mortgage.passeerdatum) }}</span>
    </td>
    <td>{{ mortgage.agency_name }}</td>
    <td>
      <span v-for="address in collateralAddresses">{{ address }} <br></span>
    </td>
    <td>{{ this.formatValuta(this.mortgage.hoofdsomHypotheek) }} <br>{{
        this.formatValuta(this.mortgage.restantHoofdsom)
      }}
    </td>
    <td>
      <span :style="{'background-color': '#'+productLabel.color}" class="label label-default"
            v-for="productLabel in productLabels"
            v-if="hasProductLabels">
          {{ productLabel.tag }}
      </span>
    </td>
    <td class="compact text-right" v-if="this.propertyId">
      <a-popconfirm
          @confirm="onUnmatchClick"
          cancel-text="Annuleren"
          class="add-collateral"
          ok-text="Ontkoppelen"
          placement="topRight"
          title="Weet je zeker dat je het huidige woonadres als onderpand wilt ontkoppelen van deze hypotheek?"
          v-if="givenPropertyIsCollateral"
          v-on:click.stop
      >
        <a-tooltip placement="left">
          <template slot="title">
            <span>Onderpand ontkoppelen</span>
          </template>
          <a-button :loading="unmatchLoading" v-on:click.stop>
            <close-thick-icon></close-thick-icon>
          </a-button>
        </a-tooltip>
      </a-popconfirm>
      <a-popconfirm
          @confirm="onMatchClick"
          cancel-text="Annuleren"
          class="add-collateral"
          ok-text="Koppelen"
          placement="topRight"
          title="Weet je zeker dat je het huidige woonadres als onderpand wilt koppelen aan deze hypotheek?"
          v-else
          v-on:click.stop
      >
        <a-tooltip placement="left">
          <template slot="title">
            <span>Als onderpand toevoegen</span>
          </template>
          <a-button :loading="matchLoading" v-on:click.stop type="primary">
            <plus-icon></plus-icon>
          </a-button>
        </a-tooltip>
      </a-popconfirm>
    </td>
  </tr>

</template>
<script>
import moment from 'moment';
import Numbers from '~/util/numbers';
import mortgagePropertyApi from '~/api/mortgage_property';
import mortgageApi from '~/api/mortgage';
import editMortgagePropertyComponent from "~/modules/mortgage_property/components/EditComponent";
import {DateFormatEnum} from "~/enums";

export default {
  name: "MortgageRowComponent",
  components: {
    editMortgagePropertyComponent
  },
  props: {
    mortgageObject: {
      type: Object,
      required: false,
      default: null
    },
    mortgageId: {
      type: [Number, String],
      required: false,
      default: null

    },
    propertyId: {
      type: Number,
      default: null,
      required: false
    },
    propertyAttachable: {
      type: Boolean,
      default: false,
      required: false
    },
  },
  data() {
    return {
      unmatchLoading: false,
      matchLoading: false,
      mortgage: {},
    }
  },
  mounted() {
    if (this.mortgageObject !== null) {
      this.mortgage = this.mortgageObject
    } else if (this.mortgageId !== null) {
      mortgageApi.find(this.mortgageId, ['mortgage_properties', 'mortgage_properties.property', 'product_labels']).then(response => {
        this.mortgage = response.data;
      })
    } else {
      // TODO:: better message
      alert("er ging iets mis bij het laden van een hypotheek")
    }

  },
  computed: {
    mortgageShowUri() {
      return '/customer/' + this.mortgage.customer_id + '/mortgage/' + this.mortgage.id
    },
    givenPropertyMortgageProperty() {
      if (this.propertyId && Object.keys(this.mortgage).length > 0) {
        if (typeof this.mortgage.mortgage_properties !== "undefined"
        ) {
          let collateral = this.mortgage.mortgage_properties.data.find((mortgageProperty) => {
            if (mortgageProperty.property_id === this.propertyId) {
              return mortgageProperty
            }
          })
          if (!collateral) {
            return false
          }
          return collateral
        }
      }
    },
    givenPropertyIsCollateral() {
      if (!this.givenPropertyMortgageProperty) {
        return false
      }
      return this.givenPropertyMortgageProperty.property_id === this.propertyId
    },
    collateralProperties() {
      let properties = [];
      if (Object.keys(this.mortgage).length > 0) {
        if (typeof this.mortgage.mortgage_properties !== "undefined") {
          this.mortgage.mortgage_properties.data.forEach((mortgageProperty) => {
            properties.push(mortgageProperty.property.data)
          })
        }
      }
      return properties
    },
    collateralAddresses() {
      let addresses = [];
      this.collateralProperties.forEach((property) => {
        addresses.push(property.formatted_address)
      })
      return addresses
    },
    productLabels() {
      let labels = [];
      if (Object.keys(this.mortgage > 0) && typeof this.mortgage.product_labels !== 'undefined') {
        this.mortgage.product_labels.data.forEach((producLabel => {
          labels.push(producLabel)
        }))
      }
      return labels;
    },
    hasProductLabels() {
      return this.productLabels.length > 0;
    }
  },
  methods: {
    onUnmatchClick() {
      this.unmatchLoading = true;
      mortgagePropertyApi.delete(this.givenPropertyMortgageProperty.id).then(() => {
        this.unmatchLoading = false;
        this.$emit('collateral-unmatch', this.givenPropertyMortgageProperty.id);
        this.reloadMortgage()
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Kon het pand niet ontkoppelen',
        });
      })
    },
    onMatchClick() {
      this.matchLoading = true;
      mortgagePropertyApi.createByMortgageAndProperty(this.mortgage.id, this.propertyId).then((response) => {
        this.matchLoading = false;
        this.$emit('collateral-match', response.data.id);
        this.reloadMortgage()

      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Kon het pand niet koppelen',
        });
      })
    },
    reloadMortgage() {
      // this.$emit('mortgage-reload');
      mortgageApi.find(this.mortgage.id, ['mortgageProperty', 'mortgage_property.property', 'product_labels']).then(response => {
        this.mortgage = response.data;
      })
    },
    formatValuta(value) {
      return value || value === 0 ? '€ ' + Numbers.thousands_separators(value.toFixed(2)) : ''
    },
    formatDate(date) {
      return moment(date, moment.ISO_8601).format(DateFormatEnum.DISPLAY_DATE);
    }
  }
}
</script>

<style scoped>
tr td.half-padding {
  padding: 4px;
}

tr:not(.selected):hover {
  background-color: #1890ff0a;
}

tr.selected {
  background-color: #1890ff1c;
}

table th.compact, table td.compact {
  white-space: nowrap;
  width: 1px !important;
}

tr .pencil-icon.edit-name {
  display: none;
}

tr:hover .pencil-icon.edit-name {
  display: initial;
}
</style>